exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "h1[data-v-33f4b654]{font-size:20px}.v-alert__content>.nuxt-link-active[data-v-33f4b654]{font-size:20px;background-color:#fff;padding:5px;border-radius:.2em;text-decoration:none;font-weight:600}", ""]);
